import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { AdminActionTypes } from '../actions/admin.actions';
var initialState = {
    allAccounts: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    accountsInCurrentDomain: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    permissions: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    loading: [],
    err: [],
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case AdminActionTypes.GET_ALL_ACCOUNTS_SUCCESS: {
            return tslib_1.__assign({}, state, { allAccounts: action.payload, loading: clearLoading(state, AdminActionTypes.GET_ALL_ACCOUNTS), err: clearError(state, AdminActionTypes.GET_ALL_ACCOUNTS) });
        }
        case AdminActionTypes.GET_ALL_ACCOUNTS_FAILURE: {
            return tslib_1.__assign({}, state, { allAccounts: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, loading: clearLoading(state, AdminActionTypes.GET_ALL_ACCOUNTS), err: addError(state, AdminActionTypes.GET_ALL_ACCOUNTS, action.payload) });
        }
        case AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN_SUCCESS: {
            return tslib_1.__assign({}, state, { accountsInCurrentDomain: action.payload, loading: clearLoading(state, AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN), err: clearError(state, AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN) });
        }
        case AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN_FAILURE: {
            return tslib_1.__assign({}, state, { accountsInCurrentDomain: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, loading: clearLoading(state, AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN), err: addError(state, AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN, action.payload) });
        }
        case AdminActionTypes.GET_PERMISSIONS_SUCCESS: {
            return tslib_1.__assign({}, state, { permissions: action.payload, loading: clearLoading(state, AdminActionTypes.GET_PERMISSIONS), err: clearError(state, AdminActionTypes.GET_PERMISSIONS) });
        }
        case AdminActionTypes.GET_PERMISSIONS_FAILURE: {
            return tslib_1.__assign({}, state, { permissions: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, loading: clearLoading(state, AdminActionTypes.GET_PERMISSIONS), err: addError(state, AdminActionTypes.GET_PERMISSIONS, action.payload) });
        }
        case AdminActionTypes.CREATE_ACCOUNT_SUCCESS: {
            return tslib_1.__assign({}, state, { allAccounts: tslib_1.__assign({}, state.allAccounts, { results: state.allAccounts.results.concat([
                        action.payload
                    ]) }), loading: clearLoading(state, AdminActionTypes.CREATE_ACCOUNT), err: clearError(state, AdminActionTypes.CREATE_ACCOUNT) });
        }
        case AdminActionTypes.CREATE_ACCOUNT_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, AdminActionTypes.CREATE_ACCOUNT), err: addError(state, AdminActionTypes.CREATE_ACCOUNT, action.payload) });
        }
        case AdminActionTypes.UPDATE_ROLES_SUCCESS: {
            if (action.payload.oauthId) {
                var index = state.allAccounts.results.findIndex(function (acc) { return acc.oauthId === action.payload.oauthId; });
                return tslib_1.__assign({}, state, { allAccounts: tslib_1.__assign({}, state.allAccounts, { results: state.allAccounts.results.slice(0, index).concat([
                            tslib_1.__assign({}, state.allAccounts.results[index], { roles: action.payload.roles })
                        ], state.allAccounts.results.slice(index + 1)) }), loading: clearLoading(state, AdminActionTypes.UPDATE_ROLES), err: clearError(state, AdminActionTypes.UPDATE_ROLES) });
            }
            else {
                return tslib_1.__assign({}, state, { loading: clearLoading(state, AdminActionTypes.UPDATE_ROLES), err: clearError(state, AdminActionTypes.UPDATE_ROLES) });
            }
        }
        case AdminActionTypes.UPDATE_ROLES_FAILURE: {
            return tslib_1.__assign({}, state, { allAccounts: state.allAccounts, loading: clearLoading(state, AdminActionTypes.UPDATE_ROLES), err: addError(state, AdminActionTypes.UPDATE_ROLES, action.payload) });
        }
        case AdminActionTypes.ACCOUNT_BATCH_UPLOAD_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, AdminActionTypes.ACCOUNT_BATCH_UPLOAD), err: clearError(state, AdminActionTypes.ACCOUNT_BATCH_UPLOAD) });
        }
        case AdminActionTypes.ACCOUNT_BATCH_UPLOAD_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, AdminActionTypes.ACCOUNT_BATCH_UPLOAD), err: addError(state, AdminActionTypes.ACCOUNT_BATCH_UPLOAD, action.payload) });
        }
        case AdminActionTypes.GET_ALL_ACCOUNTS:
        case AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN:
        case AdminActionTypes.GET_PERMISSIONS:
        case AdminActionTypes.CREATE_ACCOUNT:
        case AdminActionTypes.UPDATE_ROLES:
        case AdminActionTypes.ACCOUNT_BATCH_UPLOAD: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        default: {
            return state;
        }
    }
}
var admin = function (state) { return state.admin; };
var ɵ0 = admin;
var ɵ1 = function (state) { return state.err; }, ɵ2 = function (state) { return state.loading; }, ɵ3 = function (state) { return state.allAccounts; }, ɵ4 = function (state) { return state.accountsInCurrentDomain; }, ɵ5 = function (state) { return state.permissions; };
export var Selectors = {
    getErrors: createSelector(admin, ɵ1),
    getLoading: createSelector(admin, ɵ2),
    getAllAccounts: createSelector(admin, ɵ3),
    getAccountsInCurrentDomain: createSelector(admin, ɵ4),
    getPermissions: createSelector(admin, ɵ5),
};
function clearLoading(state, action) {
    return state.loading.filter(function (l) { return l !== action; });
}
function clearError(state, action) {
    return state.err.filter(function (err) { return err.action !== action; });
}
function addError(state, action, detail) {
    return state.err.concat([{
            action: action,
            detail: detail
        }]);
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
